import React from 'react';
import './App.css';
import Quotesapp from "./Components/Quotesapp";
import Header from "./Components/Header";


function App() {
  return (
      <>
        <Header />
        <Quotesapp />
      </>
  );
}

export default App;